import { includes } from "lodash";

// Edited on a page of their own (appointments, questionnaires #548); their post edit only sets streams and tags
const OWN_PAGES = {
  appointment: {
    editText: "js.calendars.appointment.edit",
    editUrl: (objectId: string) => `/appointments/${objectId}/edit`,
  },
  questionnaire: {
    editText: "js.questionnaires.edit_questionnaire",
    editUrl: (objectId: string) => `/questionnaires/${objectId}/edit`,
  },
};

export function hasOwnPage(type?: string | null): boolean {
  return includes(Object.keys(OWN_PAGES), type);
}

export function ownPage(type?: string | null) {
  return hasOwnPage(type)
    ? OWN_PAGES[type as keyof typeof OWN_PAGES]
    : undefined;
}
